import { Bug } from 'lucide-react'
import { cn } from '~/lib/utils'
import { FOCUS_RING } from '../focus'

interface ReporterButtonProps {
  onClick: () => void
  className?: string
}

/**
 * Low-prominence floating launcher in the bottom-right corner. Small circle so
 * it doesn't compete with primary UI; elevated on hover.
 */
export function ReporterButton({ onClick, className }: ReporterButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Report a bug"
      title="Report a bug (Cmd/Ctrl + Shift + B)"
      data-testid="bug-reporter-button"
      className={cn(
        'fixed bottom-4 right-4 z-40 flex h-10 w-10 items-center justify-center rounded-full',
        'border border-slate-200 bg-white text-slate-600 shadow-sm transition-all',
        'hover:bg-slate-50 hover:text-slate-900 hover:shadow-md',
        FOCUS_RING,
        className,
      )}
    >
      <Bug className="h-4 w-4" />
    </button>
  )
}
